<div class="container">
  @for (r of rounds; track $index) {
    <div class="round">
      @for (m of r; track $index) {
        <div class="match" [style.margin-top.px]="drawMarginTop(m.roundNumber, m.roundPosition)" [style.margin-bottom.px]="drawMarginBottom(m.roundNumber, m.roundPosition)">
          <app-tie-scorecard type="draw" [isDraw]="true" [tie]="m"></app-tie-scorecard>
        </div>
      }
      
    </div>
  }
</div>